<template>
  <PageContainer title="Relatório monitoria" class="relatorios-container">
    <DropdownCard title="Alunos Cadastrados">
      <AccountMultipleOutline slot="icon" />

      <div slot="body" class="dropdown-content">
        <RelatorioCard v-for="item in registered" :key="item.title" :title="item.title" :description="item.description"
          @onAction="item.fn" />
      </div>
    </DropdownCard>

    <DropdownCard title="Aulas Práticas">
      <Steering slot="icon" />

      <div slot="body" class="dropdown-content">
        <RelatorioCard v-for="pratica in praticas" :key="pratica.title" :title="pratica.title"
          :description="pratica.description" @onAction="pratica.fn" />
      </div>
    </DropdownCard>

    <DropdownCard title="Aulas Teóricas">
      <SchoolOutline slot="icon" />

      <div slot="body" class="dropdown-content">
        <RelatorioCard v-for="teorica in teoricas" :key="teorica.title" :title="teorica.title"
          :description="teorica.description" @onAction="teorica.fn" />
      </div>
    </DropdownCard>

    <DropdownCard title="Todas as Aulas">
      <SchoolOutline slot="icon" />

      <div slot="body" class="dropdown-content">
        <RelatorioCard v-for="other in allClasses" :key="other.title" :title="other.title"
          :description="other.description" @onAction="other.fn" />
      </div>
    </DropdownCard>

    <DropdownCard title="Logs">
      <PostOutline slot="icon" />

      <div slot="body" class="dropdown-content">
        <RelatorioCard v-for="log in logs" :key="log.title" :title="log.title" :description="log.description"
          @onAction="log.fn" />
      </div>
    </DropdownCard>

    <AlunosCadastradosModal ref="alunosCadastradosModal" />
    <CunsultasAlunosModal ref="cunsultasAlunosModal" />

    <AgendadasHojeModal ref="agendadasHojeModal" />
    <PendentesERejeitadasModal ref="pendentesERejeitadasModal" />
    <PorPeriodoModal ref="porPeriodoModal" />

    <TeoricasAgendadasHojeModal ref="teoricasAgendadasHojeModal" />
    <TeoricasPorPeriodoModal ref="teoricasPorPeriodoModal" />
    <TeoricasRejeitadasModal ref="teoricasRejeitadasModal" />
    <TeoricasAguardandoProcessamentoModal ref="teoricasAguardandoProcessamentoModal" />

    <EnviadasEPendentesModal ref="enviadasEPendentesModal" />
    <QuantitativosFotosModal ref="quantitativosFotosModal" />
    <QuantidadeAulasPorPeriodoModal ref="quantidadeAulasPorPeriodoModal" />
    <FotosPorAlunoModal ref="fotosPorAlunoModal" />
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import DropdownCard from 'core/DropdownCard'
import RelatorioCard from 'core/RelatorioCard'
import AccountMultipleOutline from 'icons/AccountMultipleOutline'
import Steering from 'icons/Steering'
import SchoolOutline from 'icons/SchoolOutline'
import PostOutline from 'icons/PostOutline'
import AlunosCadastradosModal from './modal/AlunosCadastradosModal'
import CunsultasAlunosModal from './modal/CunsultasAlunosModal'
import AgendadasHojeModal from './modal/AgendadasHojeModal'
import PendentesERejeitadasModal from './modal/PendentesERejeitadasModal'
import PorPeriodoModal from './modal/PorPeriodoModal'
import TeoricasAgendadasHojeModal from './modal/TeoricasAgendadasHojeModal'
import TeoricasPorPeriodoModal from './modal/TeoricasPorPeriodoModal'
import TeoricasRejeitadasModal from './modal/TeoricasRejeitadasModal'
import TeoricasAguardandoProcessamentoModal from './modal/TeoricasAguardandoProcessamentoModal'
import EnviadasEPendentesModal from './modal/EnviadasEPendentesModal'
import QuantitativosFotosModal from './modal/QuantitativosFotosModal'
import QuantidadeAulasPorPeriodoModal from './modal/QuantidadeAulasPorPeriodoModal'
import FotosPorAlunoModal from './modal/FotosPorAlunoModal'

export default {
  name: 'Relatorios',
  components: {
    PageContainer,
    DropdownCard,
    RelatorioCard,

    AccountMultipleOutline,
    Steering,
    SchoolOutline,
    PostOutline,

    AlunosCadastradosModal,
    CunsultasAlunosModal,
    AgendadasHojeModal,
    PendentesERejeitadasModal,
    PorPeriodoModal,
    TeoricasAgendadasHojeModal,
    TeoricasPorPeriodoModal,
    TeoricasRejeitadasModal,
    TeoricasAguardandoProcessamentoModal,
    EnviadasEPendentesModal,
    QuantitativosFotosModal,
    QuantidadeAulasPorPeriodoModal,
    FotosPorAlunoModal,
  },
  data() {
    return {
      registered: [
        {
          title: 'Relatório de Alunos Cadastrados',
          description: 'Tenha acesso a uma visão detalhada de todos os alunos cadastrados dentro de um período de tempo.',
          fn: () => this.openModal('alunosCadastradosModal'),
        },
        {
          title: 'Relatório de Consultas',
          description: 'Tenha acesso a uma visão detalhada de todas as consultas de alunos feitas no GETRAN dentro de um período de tempo.',
          fn: () => this.openModal('cunsultasAlunosModal'),
        },
      ],
      praticas: [
        {
          title: 'Agendadas Hoje',
          description: 'Visualize todas as aulas agendadas para o dia, organizados de forma prática para acompanhamento em tempo real.',
          fn: () => this.openModal('agendadasHojeModal'),
        },
        {
          title: 'Pendentes e Rejeitadas',
          description: 'Acompanhe as aulas pendentes e as rejeitadas, com detalhes sobre o status, motivos e ações necessárias para regularização.',
          fn: () => this.openModal('pendentesERejeitadasModal'),
        },
        {
          title: 'Por Período',
          description: 'Filtre e analise as informações selecionando um intervalo de datas específico, obtendo dados detalhados e relevantes por período.',
          fn: () => this.openModal('porPeriodoModal'),
        },
      ],
      teoricas: [
        {
          title: 'Agendadas Hoje',
          description: 'Confira todas as aulas agendadas para hoje, com detalhes de horário, aluno, veículo e instrutor para uma gestão eficiente do dia.',
          fn: () => this.openModal('teoricasAgendadasHojeModal'),
        },
        {
          title: 'Agendadas por Período',
          description: 'Visualize o histórico de aulas agendadas dentro de um intervalo de datas, com informações organizadas para planejamento e análise.',
          fn: () => this.openModal('teoricasPorPeriodoModal'),
        },
        {
          title: 'Rejeitadas',
          description: 'Acesse as aulas rejeitadas, com motivos detalhados e status para acompanhamento e possíveis reprogramações.',
          fn: () => this.openModal('teoricasRejeitadasModal'),
        },
        {
          title: 'Aguardando processamento',
          description: 'Veja as solicitações de aulas que ainda estão em processamento, permitindo monitorar pendências e agilizar confirmações.',
          fn: () => this.openModal('teoricasAguardandoProcessamentoModal'),
        },
        {
          title: 'Fotos por Aluno',
          description: 'Visualize e gerencie as fotos dos alunos, associadas a suas aulas ou documentação, garantindo conformidade com os requisitos.',
          fn: () => this.openModal('fotosPorAlunoModal'),
        },
      ],
      allClasses: [
        {
          title: 'Enviadas e Pendentes',
          description: 'Acompanhe o status das aulas enviadas e pendentes, com detalhes para verificar conformidade e completar os passos necessários.',
          fn: () => this.openModal('enviadasEPendentesModal'),
        },
        {
          title: 'Quantitativos de Fotos Registradas',
          description: 'Veja o total de fotos registradas pelos alunos, organizadas por categorias, períodos ou aulas, facilitando a gestão visual.',
          fn: () => this.openModal('quantitativosFotosModal'),
        },
        {
          title: 'Quantidade de Aulas por Período',
          description: 'Analise o número total de aulas realizadas ou agendadas dentro de um intervalo de datas, com insights para planejamento e acompanhamento.',
          fn: () => this.openModal('quantidadeAulasPorPeriodoModal'),
        },
      ],
      logs: [
        {
          title: 'Visualizar eventos de Minimização do app pelo Alunos',
          description: 'Acompanhe registros de quando o aplicativo foi minimizado pelos alunos, ajudando a entender padrões de uso e possíveis interrupções durante as aulas.',
          fn: () => this.$router.push({ name: 'LogsMinimizacao' }),
        },
        {
          title: 'Visualizar agendamentos Realizados',
          description: 'Veja todos os agendamentos confirmados pelos alunos, com detalhes sobre datas, horários, veículos e instrutores, garantindo um controle completo.',
          fn: () => this.$router.push({ name: 'LogsAgendamento' }),
        },
        {
          title: 'API Consumo',
          description: 'Veja todo consumo a api de candidato prático do Getran.',
          fn: () => this.$router.push({ name: 'LogsApiCandidatoPratico' }),
        },
      ],
    }
  },
  methods: {
    openModal(modal) {
      this.$refs[modal].open()
    },
  },
}
</script>

<style lang="scss" scoped>
.relatorios-container {
  .dropdown-content {
    padding: 1.5rem 2rem;

    display: flex;
    flex-direction: column;
    gap: 3rem;
  }
}
</style>
